import { NavLink } from 'react-router-dom';

interface Props {
  to: string;
  name: string;
}

const NavItem = ({ to, name }: Props) => {
  return (
    <NavLink
      className={({ isActive }) => {
        let classes = 'text-center no-underline';

        if (isActive) {
          return classes + ' text-amber-500';
        }
        return classes + ' hover:text-amber-500';
      }}
      to={to}
    >
      {name}
    </NavLink>
  );
};

export default NavItem;
